import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import Home from "@/views/Home/Index.vue";
import Login from "@/views/Login.vue";
import Delegation from "@/views/Delegation/Index.vue";
import CorporateGov from "@/views/CorporateGovernance/Index.vue";
import SSO from "@/views/SSO/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/login",
    name: "Login",
    meta: { layout: "login-layout" },
    component: Login,
  },
  {
    path: "/delegation",
    name: "Delegation",
    component: Delegation,
  },
  {
    path: "/corporateGov",
    name: "CorporateGov",
    component: CorporateGov,
  },
  {
    path: "/SSO/:id",
    name: "SSO",
    props: true,
    component: SSO,
  },
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const token = JSON.parse(localStorage.getItem("token"));

  if (authRequired && !token) {
    next({ name: "Login" });
  } else {
    if (token) {
      store
        .dispatch("setActiveUser", { token: token.token })
        .then((result) => {
          next();
        })
        .catch((error) => {
          if (error.response.data.error == "Token Expired" || error.response.data.error == "Password Expired") {
            localStorage.removeItem("token");
            next({name: "Login"});
          }
        });
    } else {
      next();
    }
  }
});

export default router;
